import type { MonospaceSettings } from '#layers/data-model';
import { RStoreSchema } from '#imports';
import { SINGLETON_KEY } from '~/rstore/utils/singleton';

export const Settings = RStoreSchema.withItemType<MonospaceSettings>().defineCollection({
	getKey: () => SINGLETON_KEY,
	name: 'MonospaceSettings',
	scopeId: 'monospace-default',
	meta: {
		singleton: true,
		defaultFields: ['id'],
		endpoint: 'settings',
		useProjectSlug: true,
	},
});
